<template>
  <v-layout
    v-if="!$apollo.loading"
    wrap
    justify-center
  >
    <v-flex
      xs12
    >
      <v-radio-group
        v-if="!hidePacks"
        v-model="radios"
        :mandatory="false"
      >
        <v-card
          class="pack-card mt-5"
          :class="radios == premium.id ? 'active': ''"
          justify-center
          text-center
          :ripple="false"
          @click="radios = premium.id"
        >
          <v-layout 
            pack-header 
            wrap
            align-center
            pt-5
          >
            <v-flex
              xs1
              pl-1
            >
              <v-radio
                color="primary"
                :value="premium.id"
                :ripple="true"
              />
            </v-flex>
            <v-flex
              xs11
              pl-2
            >
              <span class="title">{{ $t('packs.premium') }}</span><br>
              ${{ premium.price }} {{ premium.currency }}
              <span> / {{ $t('packs.oneTime') }}</span>
            </v-flex>
            <v-flex
              xs12
              mt-3
            >
              <v-divider />
            </v-flex>
          </v-layout>
          <v-layout 
            pack-body 
            wrap
            align-center
            pa-5
          >
            <v-flex xs1 />
            <v-flex xs11>
              <v-chip
                style="font-size:15px;"
                color="success"
                pill
              >
                6 {{ $t('packs.connections') }}
              </v-chip><br>
              <span class="mt-3 mb-3">
                {{ $t('packs.youCanDiv') }}
              </span>
            </v-flex>
            <v-flex
              xs1
            >
              <v-icon class="text-positive">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
             
              xs11
            >
              <span>{{ $t('packs.riksManagement') }}</span> 
            </v-flex>
            <v-flex
              
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
             
              xs11
            >
              <span>{{ $t('packs.copyTrading') }}</span>
            </v-flex>
            <v-flex
             
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
             
              xs11
            >
              <span>{{ $t('packs.configTrading') }}</span>
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs11
            >
              <span>{{ $t('packs.unlimitedInvestorAccs') }}</span> 
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs11
            >
              <span>{{ $t('packs.initAivdrop') }},  {{ $t('packs.value') }} $100 USDT</span> 
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore1"
              xs11
            >
              <span>{{ $t('packs.allFunc') }}</span> 
            </v-flex>
            <v-flex xs1 />
            <v-flex
              xs11
              style="cursor:pointer;"
              @click.stop="seeMore1 = !seeMore1"
            >
              <span><b>{{ seeMore1 ? $t('packs.seeLess') : $t('packs.seeMore') }}</b>
                <v-icon>
                  {{ seeMore1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </span> 
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          class="pack-card mt-5"
          :class="radios == vip.id ? 'active': ''"
          justify-center
          text-center
          :ripple="false"
          @click="radios = vip.id"
        >
          <v-layout 
            pack-header 
            wrap
            align-center
            pt-5
          >
            <v-flex
              xs1
              pl-1
            >
              <v-radio
                color="primary"
                :value="vip.id"
                :ripple="true"
              />
            </v-flex>
            <v-flex
              xs11
              pl-2
            >
              <span class="title">{{ $t('packs.vip') }}</span><br>
              ${{ vip.price }} {{ vip.currency }}
              <span> / {{ $t('packs.oneTime') }}</span>
            </v-flex>
            <v-flex
              xs12
              mt-3
            >
              <v-divider />
            </v-flex>
          </v-layout>
          <v-layout 
            pack-body 
            wrap
            align-center
            pa-5
          >
            <v-flex xs1 />
            <v-flex xs11>
              <v-chip
                style="font-size:15px;"
                color="primary"
                pill
              >
                12 {{ $t('packs.connections') }}
              </v-chip><br>
              <span class="mt-3 mb-3">
                {{ $t('packs.youCanDiv2') }}
              </span>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.riksManagement') }}</span> 
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.copyTrading') }}</span>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.configTrading') }}</span>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.unlimitedInvestorAccs') }}</span> 
            </v-flex>
            <!-- <v-flex
              v-if="seeMore2 && $i18n.locale == 'ru'"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2 && $i18n.locale == 'ru'"
              xs11
            >
              <span>{{ $t('packs.academy') }},  {{ $t('packs.value') }} $260 USDT</span> 
            </v-flex> -->
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.initAivdrop') }},  {{ $t('packs.value') }} $100 USDT</span> 
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore2"
              xs11
            >
              <span>{{ $t('packs.allFunc') }}</span> 
            </v-flex>
            <v-flex xs1 />
            <v-flex
              xs11
              style="cursor:pointer;"
              @click.stop="seeMore2 = !seeMore2"
            >
              <span><b>{{ seeMore2 ? $t('packs.seeLess') : $t('packs.seeMore') }}</b>
                <v-icon>
                  {{ seeMore2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </span> 
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          v-if="getUser && !getUser.free_pack"
          class="pack-card mt-5"
          :class="radios == 0 ? 'active': ''"
          justify-center
          text-center
          :ripple="false"
          @click="radios = 0"
        >
          <v-layout 
            pack-header 
            wrap
            align-center
            pt-5
          >
            <v-flex
              xs1
              pl-1
            >
              <v-radio
                color="primary"
                :value="0"
                :ripple="true"
              />
            </v-flex>
            <v-flex
              xs11
              pl-2
            >
              <span class="title">Free</span><br>
              ${{ 0 }}
              <span> / {{ $t('packs.free') }}</span>
            </v-flex>
            <v-flex
              xs12
              mt-3
            >
              <v-divider />
            </v-flex>
          </v-layout>
          <v-layout 
            pack-body 
            wrap
            align-center
            pa-5
          >
            <v-flex xs1 />
            <v-flex xs11>
              <v-chip
                style="font-size:15px;"
                pill
              >
                0 {{ $t('packs.connections') }}
              </v-chip><br>
              <span class="mt-3 mb-3">
                {{ $t('packs.youCanDiv3') }}
              </span>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeOneAcc') }}</span> 
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeCalcRoi') }}</span>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeRating') }}</span>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeMonitorRoi') }}</span> 
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeMonitorDrawdown') }}</span> 
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs1
            >
              <v-icon class="text-positive mr-3">
                mdi-check
              </v-icon>
            </v-flex>
            <v-flex
              v-if="seeMore3"
              xs11
            >
              <span>{{ $t('packs.freeMarkRisk') }}</span> 
            </v-flex>
            <v-flex xs1 />
            <v-flex
              xs11
              style="cursor:pointer;"
              @click.stop="seeMore3 = !seeMore3"
            >
              <span><b>{{ seeMore3 ? $t('packs.seeLess') : $t('packs.seeMore') }}</b>
                <v-icon>
                  {{ seeMore3 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </span> 
            </v-flex>
          </v-layout>
        </v-card>
      </v-radio-group>
      <v-card
        v-if="isPartner"
        class="pack-card mt-5"
        justify-center
        text-center
        :ripple="false"
      >
        <v-layout 
          pack-header 
          wrap
          align-center
          pt-5
        >
          <v-flex
            xs1
            pl-1
          >
            <v-checkbox
              v-model="partnerSelected"
              color="primary"
              :ripple="true"
            />
          </v-flex>
          <v-flex
            xs11
            pl-2
          >
            <span class="title">{{ $t("packs.affiliate") }}</span><br>
            ${{ ibo.price }} {{ ibo.currency }}
            <span> / {{ $t('packs.oneTime') }}</span>
          </v-flex>
          <v-flex
            xs12
            mt-3
          >
            <v-divider />
          </v-flex>
        </v-layout>
        <v-layout 
          pack-body 
          wrap
          align-center
          pa-5
        >
          <v-flex xs1 />
          <v-flex xs11>
            <v-chip
              class="warning"
              style="font-size:15px;color:#000;"
              pill
            >
              6 {{ $t('packs.bonuses') }}
            </v-chip><br>
            <span class="mt-3 mb-3">
              {{ $t('packs.becomeAff') }}
            </span>
          </v-flex>
        </v-layout>
      </v-card>
      
      <v-btn
        class="primary mt-3 mb-5"
        block
        x-large
        :disabled="selectedProducts.length == 0"
        @click="setProducts()"
      >
        {{ $t('packs.continueButton') }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>

const CREATE_ORDER_MUTATION = require('@/graphql/mutations/CreateOrder.gql');
const PRODUCTS_QUERY = require('@/graphql/queries/Products.gql');
import { mapGetters } from "vuex";

export default {
  name: 'Packs',
  props: {
    isPartner: {
      type: Boolean,
      default: false
    },
    isPartnerChecked: {
      type: Boolean,
      default: false
    },
     hidePacks: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      partnerSelected: false,
      radios: null,
      seeMore1: false,
      seeMore2: false,
      seeMore3: false,
      premium: null,
      vip: null,
      ibo: null,
      loading: false,
      selectedProducts: []
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
  },
  watch: {
    radios: function (val, oldval) {
      const index = this.selectedProducts.indexOf(oldval)
      if (index > -1) {
        this.selectedProducts.splice(index, 1)
      }
      this.selectedProducts.push(parseInt(val))   
    },
    partnerSelected: function (val, oldval) {
      if (val) {
        this.selectedProducts.push(parseInt(this.ibo.id))
      } else {
        const index = this.selectedProducts.indexOf(this.ibo.id)
        if (index > -1) {
          this.selectedProducts.splice(index, 1)
        }
      }
    }
  },
  methods: {
    setProducts() {
       gtag('event', 'Package Order Created', {
        'event_category': 'Package Sales',
        'event_label': 'Packages Form',
      });
      this.$emit('setProducts', this.selectedProducts)
    }
  },
  apollo: {
    products: {
      query: PRODUCTS_QUERY,
      result(data) {
        if (data.loading == false) {
          this.products.forEach(item => {
            this[item.system_name.toLowerCase()] = item
          });
          if (!this.hidePacks) {
            this.radios = this.premium.id
          }
          if (this.isPartner && this.isPartnerChecked) {
            this.partnerSelected = true
          }
        }
      },
    }
  }
}
</script>
<style lang="scss" scoped>
  .pack-card {
    &:before {
      background-color: #fff!important;
    }
    .pack-header {
      padding: 0 15px 0;
      width:100%;
      .v-input--selection-controls__input {
        margin-top:10px!important;
      }
      .title {
        font-size: 19px;
        line-height: 23px;
        font-weight: 700;
      }
    }
    .pack-body {
      span {
        font-size: 13px;
        line-height: 18px;
        display: inline-block;
      }
    }
    &.active {
      -webkit-box-shadow: 0 2px 8px 1px rgba(0,0,0,.3);
      -moz-box-shadow: 0 2px 8px 1px rgba(0,0,0,.3);
      box-shadow: 0 2px 8px 1px rgba(0,0,0,.3);
    }
  }
</style>
